import { CognitoUserPool } from 'amazon-cognito-identity-js';

export interface WindowWithConfig extends Window {
  APP_CONFIG?: {
    USER_POOL_ID?: string;
    USER_POOL_CLIENT_ID?: string;
    API_URL?: string;
    ENV?: string;
  };
}

export const getCognitoConfig = (): { userPoolId: string; clientId: string } => {
  const windowWithConfig = window as WindowWithConfig;
  const userPoolId = windowWithConfig.APP_CONFIG?.USER_POOL_ID || import.meta.env.VITE_USER_POOL_ID;
  const clientId = windowWithConfig.APP_CONFIG?.USER_POOL_CLIENT_ID || import.meta.env.VITE_USER_POOL_CLIENT_ID;

  if (!userPoolId || !clientId) {
    throw new Error('Cognito configuration not found. Please ensure USER_POOL_ID and USER_POOL_CLIENT_ID are set.');
  }

  return { userPoolId, clientId };
};

export const isLocalDev = (): boolean => {
  const windowWithConfig = window as WindowWithConfig;
  const env = windowWithConfig.APP_CONFIG?.ENV || import.meta.env.VITE_ENV;
  return env === 'local';
};

export const getApiUrl = (): string | null => {
  const windowWithConfig = window as WindowWithConfig;
  const apiUrl = windowWithConfig.APP_CONFIG?.API_URL || import.meta.env.VITE_API_URL;
  return apiUrl || null;
};

let poolInstance: CognitoUserPool | null = null;

export const getCognitoUserPool = (): CognitoUserPool => {
  if (!poolInstance) {
    const { userPoolId, clientId } = getCognitoConfig();
    poolInstance = new CognitoUserPool({
      UserPoolId: userPoolId,
      ClientId: clientId,
    });
  }
  return poolInstance;
};

export const _resetPoolForTesting = (): void => {
  poolInstance = null;
};
